import { render, staticRenderFns } from "./UndueHardship.vue?vue&type=template&id=b7c6f900"
import script from "./UndueHardship.vue?vue&type=script&lang=ts"
export * from "./UndueHardship.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports